module.exports = __webpack_public_path__ + "static/img/contact.35af330.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/contact.png
// module id = w5mg
// module chunks = 58